// TODO: Refactor this file with golden-layout typings
import { RuntimeType } from '@mae/app-engine-api/interfaces/runtime';
import { BrowserClientContentClient, FeatureAnalyzerClient } from '@mae/client-web/clients';
import { MetadataClient } from '@mae/client-web/metadataClient';
import { IMapViewListItem, IAnalyzerViewListItem } from '@mae/client-web/models';
import * as GoldenLayout from 'golden-layout';

export type StorageType = 'apps_storage' | 'studio_storage';

let mapViewsResove: (value?: IMapViewListItem[] | PromiseLike<IMapViewListItem[]>) => void;
const mapViewsPromise: Promise<IMapViewListItem[]> = new Promise((res) => {
	mapViewsResove = res;
});

let featureAnalyzerAppsResove: (value?: IAnalyzerViewListItem[] | PromiseLike<IAnalyzerViewListItem[]>) => void;
const featureAnalyzerAppsPromise: Promise<IAnalyzerViewListItem[]> = new Promise((res) => {
	featureAnalyzerAppsResove = res;
});

let goldenLayout: GoldenLayout;

export const setGoldenLayout = (_goldenLayout: GoldenLayout): GoldenLayout => (goldenLayout = _goldenLayout);

export const getParametersByName = (name: string, url?: string): string => {
	let actualUrl = url;
	if (!url) {
		actualUrl = window.location.href;
	}

	const actualName = name.replace(/[[\]]/g, '\\$&');
	const regex = new RegExp('[?&#]' + actualName + '(=([^&#]*)|&|#|$)', 'i');
	const results = regex.exec(actualUrl);

	if (!results) {
		return null;
	}

	return decodeURIComponent(results[results.length - 1].replace(/\+/g, ' '));
};

export const fetchAssets = async (storage: StorageType, tenant: string): Promise<void> => {
	MetadataClient.initialize(storage, tenant);

	if (storage == 'studio_storage') {
		mapViewsResove(await BrowserClientContentClient.getMapViews());
		featureAnalyzerAppsResove(await FeatureAnalyzerClient.getViews());
	}
};

export const getMapViews = (): Promise<IMapViewListItem[]> => {
	return mapViewsPromise;
};

export const getFeatureAnalyzerApps = (): Promise<IAnalyzerViewListItem[]> => {
	return featureAnalyzerAppsPromise;
};

export const timeout = (ms = 0): Promise<NodeJS.Timeout> => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};

export const getAllComponent = (): Array<unknown> => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return (goldenLayout._getAllContentItems() as Array<unknown>).filter((c) => c.type == 'component');
};

export const getAppTypeCount = (appType: RuntimeType): number => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const components = getAllComponent(goldenLayout);
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return components.filter((c) => c?.config?.componentName == appType).length;
};

export const isTitleUnique = (title: string): boolean => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const components = getAllComponent(goldenLayout);
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return components.filter((c) => c.title == title).length == 0;
};
